export default "__VITE_ASSET__Sdr$2_pl__"